// noinspection DuplicatedCode

import { Component, OnInit } from '@angular/core';
import { RootMixin, UserAwareMixin } from '@asp/mixins';
import { distinctUntilChanged, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent
  extends UserAwareMixin(RootMixin)
  implements OnInit
{
  luser: Observable<any>;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.luser = this.currentUser.valueChanges.pipe(
      map(({ data }: any) => data.currentUser),
      distinctUntilChanged((prev, curr) => prev.id === curr.id),
      startWith(null),
    );
  }
}
